<template>
  <section>
    <div class="container">
      <div class="row" style="margin-right: -35px;">
        <div class="col-lg-2">
          <div class="JY-sonnav">
            <ul>
              <li @click="gotoSubNav('/shipper/form')" :class="selSubNav=='/shipper/form'?'sel':''">
                <router-link to="form">
                  <i><img src="../../assets/images/icon-1.png" width="44" height="44" alt=""/></i>
                  <i class="is">
                    <img src="../../assets/images/icon-1-sel.png" width="44" height="44" alt=""/>
                  </i><br>发布货源
                </router-link><span></span>
              </li>
              <li id="shipper-goods" @click="gotoSubNav('/shipper/goods')" :class="selSubNav=='/shipper/goods'?'sel':''">
                <router-link to="goods">
                  <i><img src="../../assets/images/icon-5.png" width="44" height="44" alt=""/></i>
                  <i class="is">
                    <img src="../../assets/images/icon-5-sel.png" width="44" height="44" alt=""/>
                  </i><br>我的货源
                </router-link><span></span>
              </li>
              <li @click="gotoSubNav('/shipper/orders')" :class="selSubNav=='/shipper/orders'?'sel':''">
                <router-link to="orders">
                  <i><img src="../../assets/images/icon-2.png" width="44" height="44" alt=""/></i>
                  <i class="is">
                    <img src="../../assets/images/icon-2-sel.png" width="44" height="44" alt=""/>
                  </i><br>我的订单
                </router-link><span></span>
              </li>
              <li @click="gotoSubNav('/shipper/complaints')" :class="selSubNav=='/shipper/complaints'?'sel':''">
                <router-link to="complaints">
                  <i><img src="../../assets/images/icon-complaints.png" width="44" height="44" alt=""/> </i>
                  <i class="is">
                    <img src="../../assets/images/icon-complaints-sel.png" width="44" height="44" alt=""/>
                  </i><br>投诉建议
                </router-link><span></span>
              </li>
            </ul>
          </div>
        </div>
        <router-view/>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    data() {
      return {
        selSubNav: this.$router.currentRoute.path,
      };
    },
    methods: {
      gotoSubNav(nav) {
        this.selSubNav = nav;
      }
    },
    mounted() {}
  };
</script>
<style>
  .JY-sonnav li{
    padding: 0;
    width:100px;
    height: 100px;
  }
  .JY-sonnav li a{
    display: block;
    height: 100%;
    width:100%;
    padding-top: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Shipper/Index.vue